import React from 'react'
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { Bounce, toast,  } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { findUser } from "../api/userApi";
import { useAuth } from '../context/AuthContext';

export default function GoogleSignUp({ onSuccess }) {
  const {setUserData} = useAuth();
    const { t } = useTranslation();
    const navigate =useNavigate();
    const handleGoogle = async () => {
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      try {
        const { user } = await signInWithPopup(auth, provider);
        let loginuser = null;
        try {
          loginuser = await findUser(user.email);
        } catch (findErr) {
          if (findErr?.response?.data?.error !== "User not found.") {
            onSuccess({
                email: user.email || "",
                displayName: user.displayName || "",
                username: user.displayName.replaceAll(" ", "") || "",
                phoneNumber: user.phoneNumber || "",
              });
          }
        }
    
        if (loginuser) {
            setUserData(loginuser);
          navigate(`/`);
          return;
        }

      } catch (err) {
        console.error(err);
        toast.error(t("googleError"), {
          position: "top-center",
          autoClose: 3000,
          transition: Bounce,
        });
      }
    };
  
    return (
      <button
        onClick={handleGoogle}
        className="w-full flex items-center justify-center gap-2 bg-slate-900 text-white py-3 rounded-full hover:bg-[#357ae8] transition"
      >
        <svg
          className="w-5 h-5"
          height="100%"
          viewBox="0 0 20 20"
          width="100%"
          fit=""
          preserveAspectRatio="xMidYMid meet"
          focusable="false"
        >
          <path
            d="M19.6 10.23c0-.82-.1-1.42-.25-2.05H10v3.72h5.5c-.15.96-.74 2.31-2.04 3.22v2.45h3.16c1.89-1.73 2.98-4.3 2.98-7.34z"
            fill="#4285F4"
          ></path>
          <path
            d="M13.46 15.13c-.83.59-1.96 1-3.46 1-2.64 0-4.88-1.74-5.68-4.15H1.07v2.52C2.72 17.75 6.09 20 10 20c2.7 0 4.96-.89 6.62-2.42l-3.16-2.45z"
            fill="#34A853"
          ></path>
          <path
            d="M3.99 10c0-.69.12-1.35.32-1.97V5.51H1.07A9.973 9.973 0 000 10c0 1.61.39 3.14 1.07 4.49l3.24-2.52c-.2-.62-.32-1.28-.32-1.97z"
            fill="#FBBC05"
          ></path>
          <path
            d="M10 3.88c1.88 0 3.13.81 3.85 1.48l2.84-2.76C14.96.99 12.7 0 10 0 6.09 0 2.72 2.25 1.07 5.51l3.24 2.52C5.12 5.62 7.36 3.88 10 3.88z"
            fill="#EA4335"
          ></path>
        </svg>
        {t("Continue With Google")}
      </button>
    );
}
